import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { UserForgotPasswordPageContent } from "./UserForgotPasswordPageContent";

export interface IUserForgotPasswordPageOwnProps {
}

export interface IUserForgotPasswordPageStateProps {
}

export interface IUserForgotPasswordPageDispatchProps {
}

export interface IUserForgotPasswordPagePathProps {
    returnUrl: string;
}

type UserForgotPasswordPageProp = IUserForgotPasswordPageOwnProps & IUserForgotPasswordPageStateProps & IUserForgotPasswordPageDispatchProps & RouteComponentProps<IUserForgotPasswordPagePathProps>;

export class UserForgotPasswordPage extends React.Component<UserForgotPasswordPageProp, {}> {
    render() {
        return (
            <UserForgotPasswordPageContent
                returnUrl={this.props.match.params.returnUrl}
            />
        );
    }
}